import { makeAPIRequest } from '@/helpers/searchUtils'
import { SearchDataProps } from '../_types/searchDataType'
import { fetchApi } from './fetchApi'

export const fetchSearch = async (
  query,
  req = {},
  perPage = 24,
  extraApiParams = {},
): Promise<SearchDataProps> => {
  const routeOne = query?.routes?.[0]
  const routeTwo = query?.routes?.[1]
  const village = routeOne === 'village' ? routeTwo : ''
  const city = routeOne === 'city' ? routeTwo : ''
  const province = routeOne === 'province' ? routeTwo : ''
  const tag = !query.tag && routeOne === 'tag' ? routeTwo : ''
  const isMidTerm = query.mid_term ? { mid_term: 1, random: 1 } : {}
  const { phrase, ...restQueries } = query

  const checkPhraseArea = () => {
    if (!phrase) return {}
    switch (phrase) {
      case 'شمال':
        return {
          province: ['گیلان', 'مازندران', 'گلستان'],
          meta_tags: ['north'],
        }
      case 'جنوب':
        return { city: ['چابهار', 'هرمز', 'قشم', 'کیش'], meta_tags: ['south'] }
      default:
        return { phrase }
    }
  }

  const checkTehranNearCities = () => {
    const hasTehranNearCities = restQueries.near_cities?.includes('تهران')
    return hasTehranNearCities ? { meta_tags: ['around-tehran'] } : {}
  }

  const checkIsMap = () => {
    if (Number(restQueries?.from_map_nearby)) {
      if (
        !restQueries?.page ||
        !(+restQueries?.page % 5) ||
        +restQueries?.page === 1
      ) {
        return true
      }
    }
    return false
  }

  const { apiParams } = makeAPIRequest({
    queryParams: {
      ...restQueries,
      page: perPage === 1 ? +restQueries?.page * 24 - 23 : restQueries.page,
    },
    perPage,
    city,
    province,
    village,
    tag,
  })

  const initialData: SearchDataProps = {
    list: [],
    map_list: [],
    midterm_map_list: null,
    region_data: null,
    pagination: {
      total: 1,
      current_page: 1,
    },
    search_id: '',
    min_price: {
      amount: '30000',
      currency_name: 'تومان',
      currency_short_form: 'ت',
    },
    parent: null,
    discount_motivation: null,
  }
  try {
    const res = await fetchApi(
      '/house/search',
      {
        ...apiParams,
        'with[]': 'photos',
        exp: 1,
        ...extraApiParams,
        ...(checkIsMap()
          ? {
              perpage: 96,
              page: Math.floor((Number(restQueries?.page) || 0) / 5) + 1,
            }
          : {
              ...checkTehranNearCities(),
              ...checkPhraseArea(),
            }),

        ...isMidTerm,
      },
      req,
    )
    const data: SearchDataProps = {
      list: res?.data?.records,
      min_price: !res?.data?.min_price?.amount
        ? {
            amount: 30000,
            currency_name: 'تومان',
            currency_short_form: 'ت',
          }
        : res?.data?.min_price,
      pagination: res?.data?.pagination,
      region_data: res?.data?.region_data,
      parent: res?.data?.parent,
      search_id: res?.data?.search_id,
      map_list: res?.data?.records,
      midterm_map_list: res?.data?.records,
      discount_motivation: res?.data?.discount_motivation,
    }
    return res ? data : initialData
  } catch (error) {
    return initialData
  }
}
